import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    messages: [],
    threads: null,
    threadsLoading: false,
    threadsFiltering: false,
    threadsFilters: {},
    // How many threads the after-hours auto-reply closed. Lives apart from
    // `threads` because that list holds open threads by default, and these are
    // closed -- so they are never in it. See #5814.
    afterHoursCount: 0,
    threadsScrollPosition: 0,
    messagesLoaded: false,
    messageLoading: false,
    messagesSchemas: {},
    messagesSchemasLoaded: false,
    conversation: [],
    conversationLoading: false,
    portalRecipients: [],
    portalRecipientsLoaded: false,
  },

  mutations,
  actions,
  getters,
};
